module.exports = __webpack_public_path__ + "static/media/neou-three.897cbb32.svg";